import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'AnswersPreview',
  properties: {},

  statics: {
    breadcrumb: 'Answers Preview',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/answers_preview.js